import styled from 'styled-components';

import { PageWrapper } from '@style/pages/page.style';

export const BillingPageWrapper = styled(PageWrapper)`
  padding-right: 32px;
`;
